<template>
    <section class="settings-module">
        <!-- Loading -->
        <loading />

        <div class="settings-content">
            <div role="header" class="module-header">
                <div class="icon-text-wrapper mb-tablet-only">
                    <p
                        @click="showSidebarMenu()"
                        role="button"
                        class="turnback"
                    >
                        Menu
                    </p>
                </div>

                <h1 class="heading-4">Definições da conta</h1>

                <p class="color-text-body">
                    Gere as definições relacionadas com a tua conta de
                    administrador
                </p>
            </div>

            <form
                @submit.prevent="sendData()"
                class="form-module admin-backoffice-form"
                method="post"
                action=""
                aria-describedby="Definitions of Settings"
                enctype="application/x-www-form-urlencoded"
                autocomplete="on"
            >
                <div class="input-row">
                    <!-- EMAIL -->
                    <div class="input-row-item">
                        <div class="item-label-input">
                            <label
                                for="email"
                                class="form-label body-1 strong-600"
                                >Email*</label
                            >

                            <input
                                @focusin="inputValidation('email', email)"
                                @focusout="inputValidation('email', email)"
                                type="email"
                                class="form-control"
                                id="email"
                                placeholder=""
                                v-model="email"
                                maxlength="300"
                            />
                        </div>
                    </div>
                </div>
                <!-- 
                <div class="input-row">
                    <div class="input-row-item">
                        <div class="item-label-input">
                            <label
                                for="password"
                                class="form-label body-1 strong-600"
                                >Palavra passe atual</label
                            >

                            <input
                                v-model="password"
                                type="password"
                                class="form-control"
                                id="password"
                                @focusin="inputValidation('password', password)"
                                @focusout="
                                    inputValidation('password', password)
                                "
                                maxlength="50"
                                ref="password"
                            />
                            <span
                                @click="showHidePass($refs.password, $event)"
                                data-show="true"
                                class="showpass toggle-password"
                            ></span>
                        </div>
                    </div>

                    <div class="input-row-item">
                        <div class="item-label-input">
                            <label
                                for="password"
                                class="form-label body-1 strong-600"
                                >Nova palavra-passe</label
                            >

                            <input
                                v-model="newpassword"
                                type="password"
                                class="form-control"
                                id="newpassword"
                                @keyup="
                                    checkPasswordStructure(
                                        newpassword,
                                        'check-password',
                                        $event
                                    )
                                "
                                @focusin="
                                    inputValidation('newpassword', newpassword),
                                        showCheckPasswordContainer(
                                            'check-password'
                                        )
                                "
                                @focusout="
                                    inputValidation('newpassword', newpassword),
                                        hideCheckPasswordContainer(
                                            'check-password'
                                        )
                                "
                                maxlength="50"
                                ref="newpassword"
                            />

                            <span
                                @click="showHidePass($refs.newpassword, $event)"
                                data-show="true"
                                class="showpass toggle-password"
                            ></span>

                            
                            <confirm-container />
                        </div>
                    </div>
                </div>
 -->

                <div class="change-password-setting">
                    <div class="item-wrapper">
                        <label for="password" class="form-label"
                            >Palavra passe atual*</label
                        >

                        <div class="input-wrapper">
                            <input
                                v-model="password"
                                type="password"
                                class="form-control"
                                id="password"
                                @focusin="inputValidation('password', password)"
                                @focusout="
                                    inputValidation('password', password)
                                "
                                maxlength="50"
                                ref="password"
                            />
                            <span
                                @click="showHidePass($refs.password, $event)"
                                data-show="true"
                                class="showpass toggle-password"
                            ></span>
                        </div>
                    </div>

                    <div class="item-wrapper">
                        <div class="d-flex flex-column">
                            <div
                                class="d-flex flex-row justify-content-between"
                            >
                                <label for="password" class="form-label"
                                    >Nova palavra-passe</label
                                >
                            </div>
                        </div>
                        <div class="input-wrapper">
                            <input
                                v-model="newpassword"
                                type="password"
                                class="form-control"
                                id="newpassword"
                                @keyup="
                                    checkPasswordStructure(
                                        newpassword,
                                        'check-password',
                                        $event
                                    )
                                "
                                @focusin="
                                    inputValidation('newpassword', newpassword),
                                        showCheckPasswordContainer(
                                            'check-password'
                                        )
                                "
                                @focusout="
                                    inputValidation('newpassword', newpassword),
                                        hideCheckPasswordContainer(
                                            'check-password'
                                        )
                                "
                                maxlength="50"
                                ref="newpassword"
                            />

                            <span
                                @click="showHidePass($refs.newpassword, $event)"
                                data-show="true"
                                class="showpass toggle-password"
                            ></span>

                            <!-- Confirm Passsword Container -->
                            <confirm-container />
                        </div>
                    </div>

                    <div class="item-wrapper">
                        <div class="d-flex flex-column">
                            <div
                                class="d-flex flex-row justify-content-between"
                            >
                                <label for="password" class="form-label"
                                    >Confirmar palavra-passe</label
                                >
                            </div>
                        </div>

                        <div class="input-wrapper">
                            <input
                                v-model="confirmpassword"
                                type="password"
                                class="form-control"
                                id="confirmpassword"
                                @focusin="
                                    inputValidation(
                                        'confirmpassword',
                                        confirmpassword
                                    )
                                "
                                @focusout="
                                    inputValidation(
                                        'confirmpassword',
                                        confirmpassword
                                    )
                                "
                                maxlength="50"
                                ref="confirmpassword"
                            />

                            <span
                                @click="
                                    showHidePass($refs.confirmpassword, $event)
                                "
                                data-show="true"
                                class="showpass toggle-password"
                            ></span>
                        </div>

                        <p class="caption-md color-text-body password-note">
                            {{ passwordindicate }}
                        </p>
                    </div>
                </div>

                <div class="btn-wrapper">
                    <button
                        type="submit"
                        class="btn btn-primary btnsubmit button-body"
                        :disabled="disabled"
                    >
                        Guardar alterações
                    </button>
                </div>
            </form>

            <!-- Response Messages -->
            <div
                @click="closeMessageBox($event)"
                class="responsebasemessage"
                ref="responsebasemessage"
            >
                <list-message />
            </div>
        </div>
    </section>
</template>
<script>
import fetchData from "./../../../fetchData.js";
import inputValidation from "./../../../validationInputs.js";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import responseMessage from "./../../../responseMessage.js";
import ConfirmPassContainer from "./../../elements/confirmPasswordContainer.vue";
import CardElement from "./../../elements/CardElement.vue";

("use strict");

export default {
    name: "SettingsModule",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        customdata: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            disabled: true,
            inputNotIsValid: true,
            activeclass: "d-flex",
            responseTimeOut: 5000,
            customData: {},
            moduleData: {},
            email: "",
            password: "",
            newpassword: "",
            checkPasswordData: [],
            checkPasswordTypes: [],
        };
    },
    created() {
        //Set Settings Data
        this.moduleData = JSON.parse(this.moduledata);
        this.email = this.moduleData.email;

        //Set Confirm Passwords Patterns
        this.checkPasswordTypes = inputValidation.confirmPasswordPatterns();
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        checkPasswordStructure(password, elementbase, element) {
            //Clean Data
            if (element.key === "Backspace") {
                this.checkPasswordData = [];

                //Remove all Icons
                if (document.querySelector(".check-password-icon")) {
                    [
                        ...document.querySelectorAll(".check-password-icon"),
                    ].forEach((value) => value.remove());
                }
            }

            if (
                (password !== "" && element.key !== "Backspace") ||
                element.key !== "Shift" ||
                element.key !== "CapsLock"
            ) {
                //Execute Confirm Password
                this.checkPasswordData = inputValidation.confirmPassword(
                    password,
                    elementbase
                );

                if (this.checkPasswordData.length > 0) {
                    //Set Confirm Password Element
                    inputValidation.confirmPasswordAddIcon(
                        elementbase,
                        this.checkPasswordData
                    );

                    //Disable Button Conditional
                    this.disabled = true;
                }
            }
        },
        showCheckPasswordContainer(elementbase) {
            if (this.checkPasswordData.length > 0) {
                //Set Confirm Password Element
                inputValidation.confirmPasswordAddIcon(
                    elementbase,
                    this.checkPasswordData
                );

                //Disable Button Conditional
                this.disabled = true;
            }

            //Show Base Element
            document
                .getElementById(`${elementbase}`)
                .classList.remove("d-none");
            document.getElementById(`${elementbase}`).classList.add("d-flex");
        },
        hideCheckPasswordContainer(elementbase) {
            //Remove all Icons
            if (document.querySelector(".check-password-icon")) {
                [...document.querySelectorAll(".check-password-icon")].forEach(
                    (value) => value.remove()
                );
            }

            //Hide Base Element
            document
                .getElementById(`${elementbase}`)
                .classList.remove("d-flex");
            document.getElementById(`${elementbase}`).classList.add("d-none");
        },
        showHidePass(inputelement, element) {
            //Execute Default Show|Hide Password method
            defaultWebsite.showPassword(inputelement, element.target);
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        inputValidation(inputid, inputvalue) {
            //Check by empty values
            if (inputvalue === "" || !inputvalue) {
                //Disable button
                this.disabled = true;

                return;
            }

            //Check Inputs
            switch (inputid) {
                //email
                case "email":
                    this.disabled = inputValidation.validNameCases(
                        7,
                        this.email
                    )
                        ? false
                        : true;

                    break;

                //Password and Newpassword
                case "password":
                case "newpassword":
                    this.disabled = inputValidation.validNameCases(
                        11,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        sendData() {
            //Check Empty Values
            if (this.email === "" || this.password === "") {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "warning",
                    "Necessário preencher os inputs indicados como obrigatórios",
                    this.activeclass,
                    this.responseTimeOut
                );

                this.disabled = true;

                return;
            }

            let dataForm = {};

            //Check Data
            ["email", "password", "newpassword"].forEach((value) => {
                switch (value) {
                    case "email":
                        if (this.email !== this.moduleData.email) {
                            dataForm[value] = this.email;
                        }

                        break;

                    default:
                        if (this.$data[value] !== "") {
                            dataForm[value] = this.$data[value];
                        }

                        break;
                }
            });

            //Check Account Data
            if (
                Object.values(dataForm).length === 1 &&
                Object.hasOwn(dataForm, "password")
            ) {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "warning",
                    "Sem dados para atualizar",
                    this.activeclass,
                    this.responseTimeOut
                );

                this.disabled = true;

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Disabled Button
            this.disabled = true;

            //Send Data
            let response = fetchData.structureTosendData(
                this.routineurl,
                dataForm,
                this.csrftolken,
                "PUT"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Success Conditional
                    if (value.classname === "success") {
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000);
                    }
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        confirmContainer: ConfirmPassContainer,
        cardElement: CardElement,
    },
};
</script>
